import { render, staticRenderFns } from "./SolidPrimaryButton.vue?vue&type=template&id=3c626290&scoped=true&"
import script from "./SolidPrimaryButton.vue?vue&type=script&lang=ts&"
export * from "./SolidPrimaryButton.vue?vue&type=script&lang=ts&"
import style0 from "./SolidPrimaryButton.vue?vue&type=style&index=0&id=3c626290&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c626290",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
